import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useChemical');

    return {
        CONNECTION_ERROR: t('connectionError'),
        ENRICH_FAILED: t('enrichFailed')
    };
};

export default useTranslation;
